<template>
  <div>
    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ infoText }}</span>
      <md-button class="md-accent" @click="onRetryClick" v-if="showRetryButton"
        >Retry</md-button
      >
    </md-snackbar>
  </div>
</template>

<script>
import { eventBus } from "../eventbus.js";

export default {
  name: "Snackbar",
  data: () => ({
    showSnackbar: false,
    position: "center",
    duration: 6000,
    isInfinity: false,
    infoText: "",
    retryAction: null,
    showRetry: false,
  }),
  computed: {
    showRetryButton() {
      return this.showRetry && this.retryAction != null;
    },
  },
  methods: {
    onRetryClick: function () {
      this.showSnackbar = false;

      switch (this.retryAction) {
        case "login":
          // TODO redirect to login again
          eventBus.showBookingDialog();
          eventBus.switchToAdminView();
          break;
        case "magic-link-sent":
          break;
        default:
          break;
      }
    },
  },
  created: function () {
    var self = this;
    eventBus.$on("new-snack-bar", function (info, retryAction) {
      self.infoText = info;
      self.showSnackbar = true;
      self.retryAction = retryAction;
      switch (retryAction) {
        case "login":
          // TODO redirect to login again
          self.showRetry = true;
          break;
        case "magic-link-sent":
          self.showRetry = false;
          break;
        default:
          break;
      }
    });
  },
};
</script>

<style>
</style>